import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,[_c(VCol,[_c('h1',[_vm._v("Reisenkostenabrechnung")])])],1),_c(VRow,[_c(VCol,{attrs:{"cols":"12","align":"left"}},[_c('router-link',{attrs:{"to":"/"}},[_c(VBtn,{attrs:{"color":"primary"}},[_vm._v("zurück")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }